import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { GetAllBlogQuery } from '@pylot-data/hooks/blog/graphql/blogQuery'

export type BlogResult = {
    blogPosts: BlogPostsResult
}

export interface BlogItems {
    publish_time: string
    identifier: string
    post_id: number
    post_url: string
    creation_time: string
    modified_time: string
}

export type BlogPostsResult = {
    total_count: number
    items: BlogItems[]
    total_pages: number
}

export interface BlogMonthYearBlogCount {
    year: string
    monthData: BlogMothBlogPostCount[]
}

export interface BlogMothBlogPostCount {
    month: string
    postCount: number
}

export type BlogPostInputVariable = {
    allPosts: boolean
}

export type GetAllBlogResult = BlogResult

async function getAllBlogs({
    locale
}: {
    locale: string
}): Promise<GetAllBlogResult> {
    const blogDataPromise = graphqlFetch<
        BlogPostInputVariable,
        GetAllBlogResult
    >({
        query: GetAllBlogQuery,
        variables: {
            allPosts: true
        },
        locale
    })
    const [blogData] = await Promise.all([blogDataPromise])
    return {
        blogPosts: blogData.data.blogPosts
    }
}

export default getAllBlogs
